import dashboard from './dashboard'
import listings from './listings'

export default {
  namespaced: true,
  modules: { listings, dashboard }
}
